import React, { useState, useEffect } from 'react';
import SummaryDisplayNews from './SummaryDisplayNews';
import { newsSummary } from '../../../../services/newsSummary';

const NewsSummaryFinancials = ({ companyData }) => {
    const [keyword, setKeyword] = useState('');
    const [summaryData, setSummaryData] = useState(null);
    const [isLoadingSummary, setIsLoadingSummary] = useState(false); 

    useEffect(() => {
        setKeyword(`${companyData.name} financials`);
    }, [companyData]);

    const fetchSummary = async () => {
        setIsLoadingSummary(true); 
        setSummaryData(null); 
        try {
            const summary = await newsSummary(keyword); 
            setSummaryData(summary); 
        } catch (error) {
            console.error('Failed to fetch analysis:', error);
        }
        setIsLoadingSummary(false); 
    }

    const handleSearchClick = () => {
        fetchSummary();
    }

    const isLoading = isLoadingSummary;

    return (
        <div>
            <button onClick={handleSearchClick}>Financials Analysis</button>
            {isLoading && <div>Thinking, please wait …</div>}
            {summaryData && <SummaryDisplayNews summary={summaryData.response} />}
        </div>
    );
}

export default NewsSummaryFinancials;